var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "update-detail" }, [
    _c("div", { staticClass: "section" }, [
      _c("div", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_vm.$t("googleDrive.channelInfo"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-content" }, [
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("googleDrive.channelName")))]),
            _vm._v(" "),
            _c("a-input", {
              attrs: { placeholder: _vm.$t("googleDrive.channelName") },
              model: {
                value: _vm.localChannel.name,
                callback: function ($$v) {
                  _vm.$set(_vm.localChannel, "name", $$v)
                },
                expression: "localChannel.name",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.localChannel.payload && _vm.localChannel.payload.email
          ? _c("div", { staticClass: "form-row" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("googleDrive.connectedAccount"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "account-info" }, [
                _vm.localChannel.payload.photoLink
                  ? _c("img", {
                      staticClass: "account-photo",
                      attrs: { src: _vm.localChannel.payload.photoLink },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "account-details" }, [
                  _c("span", { staticClass: "display-name" }, [
                    _vm._v(_vm._s(_vm.localChannel.payload.displayName)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "email" }, [
                    _vm._v(_vm._s(_vm.localChannel.payload.email)),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.localChannel.payload && _vm.localChannel.payload.storageQuota
          ? _c("div", { staticClass: "form-row" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("googleDrive.storageQuota")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "storage-info" },
                [
                  _c("a-progress", {
                    attrs: {
                      percent: _vm.storagePercent,
                      status: _vm.storagePercent > 90 ? "exception" : "normal",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "storage-text" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.formatBytes(
                            _vm.localChannel.payload.storageQuota.usage
                          )
                        ) +
                        " / \n                        " +
                        _vm._s(
                          _vm.formatBytes(
                            _vm.localChannel.payload.storageQuota.limit
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section-footer" },
      [
        _c(
          "SupsisButton",
          {
            attrs: { primary: "", loading: _vm.saving },
            on: { click: _vm.save },
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$t("message.save")) + "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }